import React, { useEffect, useState } from 'react';
import TransactionApi from '../api/TransactionApi';
import SettingApi from '../api/SettingApi';

const getTodayString = () => {
  const today = new Date();
  return today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
};

const DailyReport = () => {
  const [selectedDate, setSelectedDate] = useState(getTodayString());
  const [categoryExpenses, setCategoryExpenses] = useState({});
  const [totalExpense, setTotalExpense] = useState(0);
  const [categoryIncomes, setCategoryIncomes] = useState({});
  const [totalIncome, setTotalIncome] = useState(0);
  const [categoryProfits, setCategoryProfits] = useState({});
  const [totalProfit, setTotalProfit] = useState(0);
  const [setting, setSetting] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
      getSettings();
  }, []);

  useEffect(() => {
    getTransactions(selectedDate);
    const fetchData = async () => {
      setIsLoading(true); // Set loading to true
      await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulate a delay
      setIsLoading(false); // Set loading to false after the task is complete
    };

    fetchData();
  }, [selectedDate]);

  // console.log('selectedDate', selectedDate)

  const getSettings = async () => {
    const res = await SettingApi.index();
    const data = (res);
    setSetting(data);
  };

  const getTransactions = async (date) => {
    const res = await TransactionApi.incomes();
    const categoryExpenseData = {};
    const categoryIncomeData = {};
  
    res.forEach((transaction) => {
      const { amount, paid_at, type, cat_name } = transaction;
      const parsedAmount = parseFloat(amount);
      const transactionDate = new Date(paid_at);
  
      // Format the transaction date according to the setting.region
      const formattedTransactionDate = new Intl.DateTimeFormat(setting?.region || 'en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(transactionDate);
  
      // Format the input date similarly
      const inputDate = new Intl.DateTimeFormat(setting?.region || 'en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date(date));
  
      if (formattedTransactionDate === inputDate) {
        const categoryName = cat_name || 'Uncategorized';
        if (type === 'expense') {
          if (!categoryExpenseData[categoryName]) {
            categoryExpenseData[categoryName] = 0;
          }
          categoryExpenseData[categoryName] += parsedAmount;
        } else if (type === 'income') {
          if (!categoryIncomeData[categoryName]) {
            categoryIncomeData[categoryName] = 0;
          }
          categoryIncomeData[categoryName] += parsedAmount;
        }
      }
    });
  
    setCategoryExpenses(categoryExpenseData);
    setCategoryIncomes(categoryIncomeData);
  
    const totalExpense = Object.values(categoryExpenseData).reduce((sum, expense) => sum + expense, 0);
    const totalIncome = Object.values(categoryIncomeData).reduce((sum, income) => sum + income, 0);
    const totalProfit = totalIncome - totalExpense;
  
    setTotalExpense(totalExpense);
    setTotalIncome(totalIncome);
    setTotalProfit(totalProfit);
  
    const newCategoryProfits = {};
    for (const catName of new Set([...Object.keys(categoryExpenseData), ...Object.keys(categoryIncomeData)])) {
      const expense = categoryExpenseData[catName] || 0;
      const income = categoryIncomeData[catName] || 0;
      newCategoryProfits[catName] = income - expense;
    }
    setCategoryProfits(newCategoryProfits);
  };
  

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  return (
    <div>
      {isLoading ? (
        <div className="loading">
          <p>Loading...</p>
          {/* Add a spinner if you want */}
        </div>
      ) : (
      <div className="mx-auto">
        <div className="flex flex-col mb-4">
          <label htmlFor="date" className="text-sm font-medium text-gray-700 dark:text-gray-400">Select Date:</label>
          <input
            type="date"
            id="date"
            value={selectedDate}
            onChange={handleDateChange}
            className="mt-1 px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm w-32"
          />
        </div>
        <div className="flex flex-col">
          <div className="overflow-x-auto shadow-md sm:rounded-lg">
            <div className="inline-block min-w-full align-middle">
              <div className="overflow-hidden">
                {/* Table */}
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-100 dark:bg-gray-700">
                    <tr>
                    <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"> 
                        Income Source
                      </th>
                      <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"> 
                        Expense Source
                      </th>
                      <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"> 
                        Income Amount
                      </th>
                      <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Expence Amount
                      </th>
                      <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Total Amount
                      </th>
                    </tr>
                  </thead>
                  {/* table */}
                  <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">

                    {/* Income */}

                    {Object.entries(categoryIncomes).map(([catName, income]) => (
                      <tr key={catName} className="hover:bg-gray-100 dark:hover:bg-gray-700">
                        <td className="py-4 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white">
                          {catName}
                        </td>

                        <td></td>

                        <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          {income.toFixed(2)}
                        </td>

                        <td></td>

                        <td></td>

                      </tr>
                    ))}

                    {/* Expence */}

                    {Object.entries(categoryExpenses).map(([catName, expense]) => (
                      <tr key={catName} className="hover:bg-gray-100 dark:hover:bg-gray-700">
                        <td></td>
                        <td className="py-4 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white">
                          {catName}
                        </td>
                        <td></td>
                        <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          {expense.toFixed(2)}
                        </td>
                        <td></td>
                      </tr>
                    ))}
                    {/* total Expence */}
                    <tr className="hover:bg-gray-100 dark:hover:bg-gray-700">
                      <td className="py-4 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white">
                        Total
                      </td>
                      <td></td>
                      <td className="py-4 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white" >{totalIncome.toFixed(2)}</td>
                      <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        {totalExpense.toFixed(2)}
                      </td>
                      <td className="py-4 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white" >{totalProfit.toFixed(2)}</td>
                    </tr>
                  </tbody>
                </table>

                {/* <div className="mt-4 text-center text-lg font-semibold text-gray-700 dark:text-gray-400">
                  Total Daily Expense: {totalExpense.toFixed(2)}
                </div> */}
              </div>

              {/* <div className="overflow-hidden">
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-100 dark:bg-gray-700">
                    <tr>
                      <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"> 
                      </th>

                      <th></th>

                      <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                      </th>

                      <th></th>

                      <th></th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                    
                    <tr className="hover:bg-gray-100 dark:hover:bg-gray-700">
                      <td className="py-4 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white">
                        Total
                      </td>
                      <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        {totalIncome.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className="mt-4 text-center text-lg font-semibold text-gray-700 dark:text-gray-400">
                  Total Daily Income: {totalIncome.toFixed(2)}
                </div>
              </div> */}

              {/* <div className="overflow-hidden">
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-100 dark:bg-gray-700">
                    <tr>
                      <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"> 
                        Profit Name
                      </th>
                      <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                    {Object.entries(categoryProfits).map(([catName, profit]) => (
                      <tr key={catName} className="hover:bg-gray-100 dark:hover:bg-gray-700">
                        <td className="py-4 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white">
                          {catName}
                        </td>
                        <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          {profit.toFixed(2)}
                        </td>
                      </tr>
                    ))}
                    <tr className="hover:bg-gray-100 dark:hover:bg-gray-700">
                      <td className="py-4 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white">
                        Total
                      </td>
                      <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        {totalProfit.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className="mt-4 text-center text-lg font-semibold text-gray-700 dark:text-gray-400">
                  Total Daily Profit: {totalProfit.toFixed(2)}
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      )}
    </div>
  );
};

export default DailyReport;
